module.exports = __webpack_public_path__ + "img/intro.f35698c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intro.png
// module id = 940
// module chunks = 1